import { render, staticRenderFns } from "./editProject.vue?vue&type=template&id=6d4ce9d8&scoped=true&"
import script from "./editProject.vue?vue&type=script&lang=js&"
export * from "./editProject.vue?vue&type=script&lang=js&"
import style0 from "./editProject.vue?vue&type=style&index=0&id=6d4ce9d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4ce9d8",
  null
  
)

export default component.exports